import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setStatus({ commit }, status) {
    commit(types.SET_STATUS, status)
  },
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  resetModuleState({ commit, dispatch }) {
    commit(types.RESET_MODULE_STATE)
  },
  async setAllowEdit({ dispatch }, data) {
    const r = await startLoading(dispatch, 'setAllowEdit', () =>
      http.post(`servicerequest/UpdateReviewRequestAllowEdit`, data)
    )
    return r.data
  },
  async getReviewRequest({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getReviewRequest', () =>
      http.get(`servicerequest/getReviewRequest?id=${id}`)
    )
    return r.data
  },
  async getReviewRequests({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getReviewRequests', () =>
      http.get(`servicerequest/getreviewrequests`, {
        params: searchOptions
      })
    )
    return r.data
  },
  async getReviewRequestStatistics({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getReviewRequestStatistics', () =>
      http.get(`servicerequest/getreviewrequeststatistics`, {
        params: searchOptions
      })
    )
    commit(types.SET_REVIEW_REQUEST_STATISTICS, r.data)
  },
  async saveReviewRequest({ commit, state, dispatch }, review) {
    await startLoading(dispatch, 'saveReviewRequest', () =>
      http.post(`c/ServiceRequest/Upsert`, {
        id: review.id,
        notes: review.notes,
        sid: review.surrogateKey,
        updatedBy: review.updatedBy,
        imageTypeId: review.imageTypeId,
        voidReasonId: review.voidReasonId,
        voidNotes: review.voidNotes,
        reviewTypeId: review.reviewTypeId,
        serviceRequestStatus: review.status,
        reviewReasonId: review.reviewReasonId
      })
    )
  },
  async getReviewRequestReport({ commit, dispatch }, requestObj) {
    const r = await startLoading(dispatch, 'getReviewRequestReport', () =>
      http.get('report/CreateReviewPdf', {
        params: {
          id: requestObj.id,
          sendEmail: requestObj.sendEmail,
          isSubsequent: requestObj.isSubsequent
        }
      })
    )
    return r.data
  },
  async sendReviewRequestReport({ commit, dispatch }, requestObj) {
    const r = await startLoading(dispatch, 'sendReviewRequestReport', () =>
      http.get('report/CreateReviewPdf', {
        params: {
          id: requestObj.id,
          sendEmail: requestObj.sendEmail,
          isSubsequent: requestObj.isSubsequent
        }
      })
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/review-requests/actions.js